export const Types = {
    REGISTER_REQUEST: 'USERS_REGISTER_REQUEST',
    REGISTER_SUCCESS: 'USERS_REGISTER_SUCCESS',
    REGISTER_FAILURE: 'USERS_REGISTER_FAILURE',

    LOGIN_REQUEST: 'USERS_LOGIN_REQUEST',
    LOGIN_SUCCESS: 'USERS_LOGIN_SUCCESS',
    LOGIN_FAILURE: 'USERS_LOGIN_FAILURE',

    LOGOUT: 'USERS_LOGOUT',

};

export const alertConstants = {
    REQUEST: 'ALERT_REQUEST',
    SUCCESS: 'ALERT_SUCCESS',
    ERROR: 'ALERT_ERROR',
    CLEAR: 'ALERT_CLEAR',
};
export const getConstants = {
    GET_ALL_REQUEST: 'GET_ALL_REQUEST',
    GET_ALL_SUCCESS: 'GET_ALL_SUCCESS',
    GET_ALL_FAILURE: 'GET_ALL_FAILURE',

    GET_PARTICULAR_REQUEST: 'GET_PARTICULAR_REQUEST',
    GET_PARTICULAR_SUCCESS: 'GET_PARTICULAR_SUCCESS',
    GET_PARTICULAR_FAILURE: 'GET_PARTICULAR_FAILURE',

    GET_DISTRIBUTORS_LIST_REQUEST: 'GET_DISTRIBUTORS_LIST_REQUEST',
    GET_DISTRIBUTORS_LIST_SUCCESS: 'GET_DISTRIBUTORS_LIST_SUCCESS',
    GET_DISTRIBUTORS_LIST_FAILURE: 'GET_DISTRIBUTORS_LIST_FAILURE',

    CREATE_DISTRIBUTORS_REQUEST: 'CREATE_DISTRIBUTORS_REQUEST',
    CREATE_DISTRIBUTORS_SUCCESS: 'CREATE_DISTRIBUTORS_SUCCESS',
    CREATE_DISTRIBUTORS_FAILURE: 'CREATE_DISTRIBUTORS_FAILURE',

    CREATE_REQUEST: 'CREATE_REQUEST',
    CREATE_SUCCESS: 'CREATE_SUCCESS',
    CREATE_FAILURE: 'CREATE_FAILURE',

    UPDATE_REQUEST: 'CREATE_REQUEST',
    UPDATE_SUCCESS: 'CREATE_SUCCESS',
    UPDATE_FAILURE: 'CREATE_FAILURE',

    GET_ALL_USER_REQUEST: 'GET_ALL_USER_REQUEST',
    GET_ALL_USER_SUCCESS: 'GET_ALL_USER_SUCCESS',
    GET_ALL_USER_FAILURE: 'GET_ALL_USER_FAILURE',

    GET_ALL_OFFER_REQUEST: 'GET_ALL_OFFER_REQUEST',
    GET_ALL_OFFER_SUCCESS: 'GET_ALL_OFFER_SUCCESS',
    GET_ALL_OFFER_FAILURE: 'GET_ALL_OFFER_FAILURE',

    GET_ALL_DAP_REQUEST: 'GET_ALL_DAP_REQUEST',
    GET_ALL_DAP_SUCCESS: 'GET_ALL_DAP_SUCCESS',
    GET_ALL_DAP_FAILURE: 'GET_ALL_DAP_FAILURE',

    ADD_PAGINATION: 'ADD_PAGINATION',
    REMOVE_PAGINATION: 'REMOVE_PAGINATION',

    ADD_SKU_CATEGORY: 'ADD_SKU_CATEGORY',
    REMOVE_SKU_CATEGORY: 'REMOVE_SKU_CATEGORY',

};

export const ProductConstants = {
    GET_PRODUCTS_LIST_REQUEST: 'GET_PRODUCTS_LIST_REQUEST',
    GET_PRODUCTS_LIST_SUCCESS: 'GET_PRODUCTS_LIST_SUCCESS',
    GET_PRODUCTS_LIST_FAILURE: 'GET_PRODUCTS_LIST_FAILURE',
    GET_PRODUCTS_FILTERS_SUCCESS: 'GET_PRODUCTS_FILTERS_SUCCESS',
};
